export enum ScreenSizes {
  LARGE = "large",
  TABLET = "tablet",
  MOBILE = "mobile",
}
